import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import RewardPolicyLayer from "../../components/RewardPolicyLayer";

const RewardPolicyPage = () => {
     return (
          <>
               {/* MasterLayout */}
               <MasterLayout>
                    {/* Breadcrumb */}
                    <Breadcrumb title="Rewards Policy" />

                    <RewardPolicyLayer />
               </MasterLayout>
          </>
     );
};

export default RewardPolicyPage;
